import { useLocalStorage } from "@vueuse/core";
import { defineStore, skipHydrate } from "pinia";
import { toast as sonner } from "vue-sonner";
import type { NotificationType, Toast } from "@/types";

export const useToastStore = defineStore("toast", () => {
	const allToasts = useLocalStorage<Toast[]>("allToasts", []);

	function addToast(message: string, type: NotificationType = "info") {
		allToasts.value.unshift({ message, visible: true, type, ts: Date.now() });
		if (allToasts.value.length > 15) {
			allToasts.value.pop();
		}
		sonner[type](message);
	}

	return {
		allToasts: skipHydrate(allToasts),
		addToast,
		success: (message: string) => addToast(message, "success"),
		info: (message: string) => addToast(message, "info"),
		warning: (message: string) => addToast(message, "warning"),
		error: (message: string) => addToast(message, "error")
	};
});
